import { render, staticRenderFns } from "./AdditionalInformation.vue?vue&type=template&id=a97ab470"
import script from "./AdditionalInformation.vue?vue&type=script&lang=js"
export * from "./AdditionalInformation.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInformation.vue?vue&type=style&index=0&id=a97ab470&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports